import { HTTPError } from 'ky';
import type { ApiMessageResponse } from '../types';

export async function getErrorMessage(error: unknown, fallback: string): Promise<string> {
  if (!(error instanceof HTTPError)) {
    return fallback;
  }

  const body = await error.response.json<ApiMessageResponse>().catch(() => null);
  return body?.message || fallback;
}
